import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AssessmentGroupInfo } from 'app/models/evaluation/assessment-group-info.model';

@Component({
  selector: 'app-one-to-four-scale-edit',
  templateUrl: './one-to-four-scale-edit.component.html',
  styleUrls: ['./one-to-four-scale-edit.component.scss']
})
export class OneToFourScaleEditComponent {
  @Input() assessmentGroups: AssessmentGroupInfo[] = [];
  @Output() savedEmit: EventEmitter<AssessmentGroupInfo[]> = new EventEmitter<AssessmentGroupInfo[]>();

  saveFields() {
    this.savedEmit.emit(this.assessmentGroups);
  }
}
